import { signal } from "@/react/core/reactive.ts";

export const firstTimeConnect = { v: false };
export const needWaitedForMasterSignal = signal<boolean>(true);
export const needWaitedForMaster = needWaitedForMasterSignal[0];
export const setNeedWaitedForMaster = needWaitedForMasterSignal[1];

//@ts-ignore
window.needWaitedForMaster = needWaitedForMaster